import { ChartConfig } from "components/ui/chart";

import { CurrentTrendLegendMarker } from "./AnalyticsChartTooltip/LegendMarkers/CurrentTrendLegendMarker";
import { PreviousTrendLegendMarker } from "./AnalyticsChartTooltip/LegendMarkers/PreviousTrendLegendMarker";

export const chartConfig = {
  current: {
    icon: CurrentTrendLegendMarker,
    color: "var(--base-chart-1)",
  },
  previous: {
    icon: PreviousTrendLegendMarker,
    color: "var(--base-chart-3)",
  },
} satisfies ChartConfig

const SMALL_TICK_FONT_SIZE_PX = 10;
const DEFAULT_TICK_FONT_SIZE_PX = 12;

export const getChartAxisTickStyle = (fontSizePx: number = DEFAULT_TICK_FONT_SIZE_PX) => ({
  fill: 'var(--base-muted-foreground)',
  fontSize: `${fontSizePx}px`,
  fontFamily: 'var(--typography-font-family-font-sans, Inter)',
  fontStyle: 'normal',
  fontWeight: 'var(--font-weight-normal, 400)'
});

export const SMALL_CHART_AXIS_TICK_STYLE = getChartAxisTickStyle(SMALL_TICK_FONT_SIZE_PX);
export const DEFAULT_CHART_AXIS_TICK_STYLE = getChartAxisTickStyle(DEFAULT_TICK_FONT_SIZE_PX);


export type ChartData = {
    currentDate: string;
    currentValue: number;
    previousDate?: string;
    previousValue?: number;
}